import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[var(--text-primary)] text-white py-12 mt-20">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/sxgus9c0_The%20LIGHTHOUSE%20Logo.jpg" 
                alt="The Lighthouse" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-lg font-semibold">The Lighthouse</h3>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed mb-4">
              Premier coaching institute in Noida, founded by IIT-ian. 
              Specializing in Classes 1-12 with focus on conceptual clarity and board exam excellence.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/thelighthousedu?igsh=Y3VtYXZ6YTc0ZGJt"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://youtube.com/@thelighthousedu?si=N4q7l4PwqzqXRT8_"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                aria-label="YouTube"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
                </svg>
              </a>
              <a
                href="https://whatsapp.com/channel/0029Vb6qkepAe5VoFTxzBs2N"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                aria-label="WhatsApp"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition-colors">
                  Our Courses
                </Link>
              </li>
              <li>
                <Link to="/faculty" className="text-gray-300 hover:text-white transition-colors">
                  Faculty
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-white transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white transition-colors">
                  Blog & Resources
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Programs</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Primary School (1-5)</li>
              <li>Middle School (6-8)</li>
              <li>Secondary School (9-10)</li>
              <li>Science Stream PCM (11-12)</li>
              <li>Science Stream PCB (11-12)</li>
              <li>Commerce Stream (11-12)</li>
              <li>Humanities Stream (11-12)</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm">
              <a
                href="tel:+917004929531"
                className="flex items-start gap-2 text-gray-300 hover:text-white transition-colors"
              >
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span className="font-mono">+91 70049 29531</span>
              </a>
              <a
                href="tel:+919162184962"
                className="flex items-start gap-2 text-gray-300 hover:text-white transition-colors"
              >
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span className="font-mono">+91 91621 84962</span>
              </a>
              <a
                href="mailto:thelighthousedu@gmail.com"
                className="flex items-start gap-2 text-gray-300 hover:text-white transition-colors break-all"
              >
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span>thelighthousedu@gmail.com</span>
              </a>
              <div className="flex items-start gap-2 text-gray-300">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>
                  Shop No. 05, Near Defence Enclave Main Gate, 
                  Sector 44, Noida, Uttar Pradesh
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} The Lighthouse Coaching Institute. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
